<template>
  <div class="profil-container">
    <h3 class="profil-title">Halaman Pengisian Data Vendor</h3>
    <p class="profil-subtitle">Silahkan mengisi data sesuai kolom di bawah</p>

    <div class="vendor-form-wrapper">
      <input-text
        :label="'Nama Perusahaan'"
        :modelName="'vendor_name'"
        :isRequired="false"
        :mutationName="'kplhStore/SET_KPLH_FORM'"
        :storeName="'kplhStore'"
        :disabled="true"
      />
      <input-text
        :label="'Alamat Perusahaan'"
        :modelName="'vendor_address'"
        :isRequired="false"
        :mutationName="'kplhStore/SET_KPLH_FORM'"
        :storeName="'kplhStore'"
        :disabled="true"
      />
      <input-text
        :label="'Jenis Badan Usaha'"
        :modelName="'kplh_choosed_bu'"
        :isRequired="false"
        :mutationName="'kplhStore/SET_KPLH_FORM'"
        :storeName="'kplhStore'"
        :disabled="true"
      />
      <input-bidang
        :storeName="'kplhStore'"
        :modelName="'addedKbli'"
        :label="'Bidang Usaha / Jenis Pekerjaan'"
        :mutationName="'kplhStore/SET_KPLH_FORM'"
        :modalName="'modal_add_kbli'"
        :isRequired="false"
        :disabled="true"
      />
      <input-text
        :label="'Nama PIC/PJO'"
        :modelName="'pic_name'"
        :isRequired="true"
        :mutationName="'kplhStore/SET_KPLH_FORM'"
        :storeName="'kplhStore'"
        :disabled="is_vendor_done"
      />
      <input-text
        :label="'Posisi PIC/PJO'"
        :modelName="'pic_position'"
        :isRequired="true"
        :mutationName="'kplhStore/SET_KPLH_FORM'"
        :storeName="'kplhStore'"
        :disabled="is_vendor_done"
      />
      <input-text
        :label="'Email PIC/PJO'"
        :modelName="'pic_email'"
        :isRequired="true"
        :mutationName="'kplhStore/SET_KPLH_FORM'"
        :storeName="'kplhStore'"
        :disabled="is_vendor_done"
      />
      <input-phone
        :label="'No. Kontak PIC/PJO'"
        :modelName="'pic_phone'"
        :subModelName="'pic_phone_code'"
        :isRequired="true"
        :mutationName="'kplhStore/SET_KPLH_FORM'"
        :storeName="'kplhStore'"
        :disabled="is_vendor_done"
      />
      <!-- <div class="vendor-form-wrapper">
        <checkbox-form
          :label="'Kode Bidang Usaha GEMS'"
          :tables="[
            {
              name: 'Jenis Pekerjaan',
              obj_name: 'JENPEK',
              css: 'column55 mr10 all-column',
              input: false,
              type: '',
            },
            {
              name: 'Kode KBLI',
              obj_name: 'KBUG',
              css: 'column15 mr10 all-column',
              input: false,
              type: '',
            },
            {
              name: 'Nilai Risiko',
              obj_name: 'NRESIKO',
              css: 'column15 mr10',
              input: false,
              type: '',
            },
            {
              name: 'Tingkat Risiko',
              obj_name: 'TRESIKO',
              css: 'column15 mr10',
              input: false,
              type: '',
            },
          ]"
          :isRequired="true"
          :modalName="'modal_add_bidang_usaha_gems'"
          :modelName="'addedBidangUsahaGems'"
          :mutationName="'kplhStore/SET_KPLH_FORM'"
          :storeName="'kplhStore'"
          :operationAdd="'bidang_usaha_add'"
          :editMutation="'kplhStore/SET_SISTEM_MANAJEMEN'"
          :disabled="is_vendor_done"
        />
      </div> -->

      <input-tingkat-resiko
        :storeName="'kplhStore'"
        :label="'Hasil penilaian Tingkat Risiko'"
        :mutationName="'kplhStore/SET_KPLH_FORM'"
        :isRequired="false"
        :disabled="is_vendor_done"
      />
      <input-gems
        :options="company"
        :label="'Pendaftaran Company GEMS'"
        :modelName="'choosed_company'"
        :isRequired="true"
        :mutationName="'kplhStore/SET_KPLH_FORM'"
        :storeName="'kplhStore'"
        :disabled="is_vendor_done"
      />
    </div>
    <div class="profil-btn-wrapper">
      <div @click="goBack()" class="btn-landing">Kembali</div>
      <div @click="goNext()" href="" class="btn-landing">
        Selanjutnya
      </div>
    </div>

    <Kbli
      :storeName="'kplhStore'"
      :modelName="'addedKbli'"
      :label="'Bidang Usaha / Jenis Pekerjaan'"
      :mutationName="'kplhStore/SET_KPLH_FORM'"
      :modalName="'modal_add_kbli'"
      :isRequired="true"
      v-if="$store.state.kplhStore.modal_add_kbli"
    />
  </div>
</template>

<script>
import InputAddress from '../../components/forms/input-address.vue'
import InputBu from '../../components/forms/input-bu.vue'
import InputDate from '../../components/forms/input-date.vue'
import InputPhone from '../../components/forms/input-phone.vue'
import InputText from '../../components/forms/input-text.vue'
import InputPerusahaan from '../../components/forms/input-perusahaan.vue'
import InputBidang from '../../components/forms/input-bidang.vue'
import Kbli from '@/components/customModal/addBidangUsaha.vue'
import InputCheckbox from '../../components/forms/input-checkbox.vue'
import AddPerusahaan from '@/components/customModal/addPerusahaan.vue'
import InputTingkatResiko from '@/components/forms/input-tingkat-resiko.vue'
import CheckboxForm from '../../components/forms/checkbox-form.vue'
import InputGems from '../../components/forms/input-select.vue'

export default {
  components: {
    InputText,
    InputDate,
    InputAddress,
    InputBu,
    InputPhone,
    InputPerusahaan,
    InputBidang,
    Kbli,
    InputCheckbox,
    AddPerusahaan,
    InputTingkatResiko,
    CheckboxForm,
    InputGems,
  },
  data() {
    return {
      customCode: '',
      company: [],
    }
  },
  async created() {
    const gems = await this.$gemsCompanies()

    this.company = gems
  },
  computed: {
    is_vendor_done() {
      return this.$store.state.kplhStore.is_vendor_done
    },
  },
  methods: {
    checkForm() {
      let pic_name = this.$store.state.kplhStore.pic_name
      let kplh_pic_position = this.$store.state.kplhStore.pic_position
      let kplh_pic_email = this.$store.state.kplhStore.pic_email
      let kplh_pic_phone = this.$store.state.kplhStore.pic_phone

      let arr = [
        [pic_name, `Nama PIC`],
        [kplh_pic_position, 'Posisi PIC'],
        [kplh_pic_phone, 'No. Telpon PIC'],
        [this.isEmailValid(kplh_pic_email), 'Email PIC'],
      ]

      return this.multiConditions(arr)
    },
    goBack() {
      this.$store.commit('kplhStore/SET_ACTIVE_PAGE', { name: 'register' })
    },
    goNext() {
      if (this.checkForm()) {
        this.$store.commit('kplhStore/SET_ACTIVE_PAGE', { name: 'grupah' })
      }
    },
  },
}
</script>
<style scoped>
.modal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1050;
  display: block;
  overflow: hidden;
  outline: 0;
  background-color: rgba(0, 0, 0, 0.6);
}

.modal-body {
  display: flex;
  flex-direction: column;
}

.modal-input-checkbox {
  margin-right: 20px;
}
</style>
